import _ from 'lodash';

export function getTeamsIds(teams){
  return _.map(teams, (team) => {
    return `"${team.id}"`;
  });
}



// WEBPACK FOOTER //
// ./src/businessLogic/teamHelper.js